import { getCreateSlackAndEmailIntegrationInput } from '@modules/subscribe/utils/getCreateSlackAndEmailIntegrationInput';
import {
  IntegrationChannelType,
  IntegrationDirection,
  IntegrationType,
  SlackChannelInput,
  useCreateIntegrationMutation,
} from 'generated/graphql';
import { useGetUser } from 'v2/core/services/user';
import { isValidCreateOutboundIntegrationInput } from '../utils/isValidCreateOutboundIntegrationInput';

export const useCreateSlackAndEmailOutboundIntegration = () => {
  const {
    id: userID,
    tenant: { id: tenantID },
  } = useGetUser();

  const [createIntegrationMutation, { loading: isLoading }] =
    useCreateIntegrationMutation();

  const createOutboundIntegration = async (
    channelType: IntegrationChannelType,
    slackChannels: SlackChannelInput[],
    emails: string[],
  ) => {
    if (
      !isValidCreateOutboundIntegrationInput(channelType, slackChannels, emails)
    ) {
      return;
    }

    const createdOutbound = await createIntegrationMutation({
      variables: {
        tenantID,
        createdByUser: userID,
        channel: channelType,
        direction: IntegrationDirection.Outbound,
        data: getCreateSlackAndEmailIntegrationInput(
          channelType,
          slackChannels,
          emails,
        ),
        integrationType: IntegrationType.Comms,
      },
    });

    return createdOutbound.data?.createIntegration?.id;
  };

  return {
    createOutboundIntegration,
    isLoading,
  };
};
